export default __webpack_public_path__ + "static/media/WarningInvoice.1861d33f.svg";